(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urvee-featured-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.getElementById('UrveeF-Track-{{ section.id }}');
  if (!track) return;

  var cards  = Array.from(track.querySelectorAll('.urvee-fp__card'));
  var dotsEl = document.getElementById('UrveeF-Dots-{{ section.id }}');
  var dots   = dotsEl ? Array.from(dotsEl.querySelectorAll('.urvee-fp__dot')) : [];

  function isMobile() { return window.innerWidth < 750; }

  function getCardWidth() {
    if (!cards.length) return 280;
    return cards[0].offsetWidth + parseInt(getComputedStyle(track).gap || '12');
  }

  function getActiveIndex() {
    var centre = track.scrollLeft + track.offsetWidth / 2;
    return Math.min(Math.max(Math.round((centre - getCardWidth() / 2) / getCardWidth()), 0), cards.length - 1);
  }

  function updateActive() {
    if (!isMobile()) return;
    var idx = getActiveIndex();
    cards.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
    dots.forEach(function (d, i) { d.classList.toggle('urvee-fp__dot--active', i === idx); });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      track.scrollTo({ left: parseInt(this.dataset.index) * getCardWidth(), behavior: 'smooth' });
    });
  });

  var ticking = false;
  track.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () { updateActive(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });

  /* Drag-to-scroll on desktop */
  var isDown = false, startX, scrollStart;
  track.addEventListener('mousedown', function (e) {
    if (isMobile()) return;
    isDown = true; startX = e.pageX - track.offsetLeft; scrollStart = track.scrollLeft;
  });
  document.addEventListener('mouseup', function () { isDown = false; });
  track.addEventListener('mouseleave', function () { isDown = false; });
  track.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    track.scrollLeft = scrollStart - (e.pageX - track.offsetLeft - startX);
  });

  updateActive();
  window.addEventListener('resize', updateActive);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urvee-problem-statement"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[id^="UrveePS-Track-"]').forEach(function (track) {
    var sectionId = track.id.replace('UrveePS-Track-', '');
    var dots = document.querySelectorAll('[data-track="UrveePS-Track-' + sectionId + '"].urvee-ps__dot');
    var prevBtn = document.querySelector('.urvee-ps__arrow--prev[data-track="UrveePS-Track-' + sectionId + '"]');
    var nextBtn = document.querySelector('.urvee-ps__arrow--next[data-track="UrveePS-Track-' + sectionId + '"]');

    function getCardWidth() {
      var card = track.querySelector('.urvee-ps__card');
      if (!card) return 300;
      var gap = parseInt(getComputedStyle(track).gap) || 16;
      return card.offsetWidth + gap;
    }

    function updateDots() {
      var scrollLeft = track.scrollLeft;
      var cardW = getCardWidth();
      var active = Math.round(scrollLeft / cardW);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('urvee-ps__dot--active', i === active);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(this.dataset.index);
        track.scrollTo({ left: idx * getCardWidth(), behavior: 'smooth' });
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { updateDots(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });

    var isDown = false, startX, scrollStart;
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollStart = track.scrollLeft;
    });
    document.addEventListener('mouseup', function () { isDown = false; });
    track.addEventListener('mouseleave', function () { isDown = false; });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollStart - (x - startX);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urvee-process"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.getElementById('UrveeProc-Track-{{ section.id }}');
  if (!track) return;

  var cards  = Array.from(track.querySelectorAll('.urvee-proc__card'));
  var dotsEl = document.getElementById('UrveeProc-Dots-{{ section.id }}');
  var dots   = dotsEl ? Array.from(dotsEl.querySelectorAll('.urvee-proc__dot')) : [];

  /* Only run carousel logic below 750px */
  function isMobile() { return window.innerWidth < 750; }

  function getCardWidth() {
    if (!cards.length) return 300;
    return cards[0].offsetWidth + parseInt(getComputedStyle(track).gap || '12');
  }

  function getActiveIndex() {
    /* Centre of viewport relative to track */
    var centre = track.scrollLeft + track.offsetWidth / 2;
    var cw = getCardWidth();
    return Math.min(Math.round((centre - cw / 2) / cw), cards.length - 1);
  }

  function updateActive() {
    if (!isMobile()) return;
    var idx = getActiveIndex();
    cards.forEach(function (c, i) {
      c.classList.toggle('is-active', i === idx);
    });
    dots.forEach(function (d, i) {
      d.classList.toggle('urvee-proc__dot--active', i === idx);
    });
  }

  /* Dot click */
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var idx = parseInt(this.dataset.index);
      track.scrollTo({ left: idx * getCardWidth(), behavior: 'smooth' });
    });
  });

  /* Scroll listener */
  var ticking = false;
  track.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () { updateActive(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });

  /* Drag-to-scroll on desktop */
  var isDown = false, startX, scrollStart;
  track.addEventListener('mousedown', function (e) {
    if (!isMobile()) { isDown = true; startX = e.pageX - track.offsetLeft; scrollStart = track.scrollLeft; }
  });
  document.addEventListener('mouseup', function () { isDown = false; });
  track.addEventListener('mouseleave', function () { isDown = false; });
  track.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    track.scrollLeft = scrollStart - (e.pageX - track.offsetLeft - startX);
  });

  /* Initial state */
  updateActive();
  window.addEventListener('resize', updateActive);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urvee-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStoryCarousel(section) {
    var track = section.querySelector('[id^="UrveeStoryTrack-"]');
    var dotsWrap = section.querySelector('[id^="UrveeStoryDots-"]');
    if (!track) return;

    var cards = Array.from(track.children);
    var dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.urvee-story__dot')) : [];
    var activeIdx = 0;

    function setActive(idx) {
      if (idx === activeIdx && cards[idx] && cards[idx].classList.contains('is-active')) return;
      activeIdx = idx;
      cards.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('urvee-story__dot--active', i === idx); });
    }

    function onScroll() {
      var centre = track.scrollLeft + track.offsetWidth / 2;
      var closest = 0, minDist = Infinity;
      cards.forEach(function (c, i) {
        var dist = Math.abs((c.offsetLeft + c.offsetWidth / 2) - centre);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      setActive(closest);
    }

    setActive(0);
    track.addEventListener('scroll', onScroll, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10);
        var target = cards[idx];
        if (target) {
          track.scrollTo({ left: target.offsetLeft - (track.offsetWidth - target.offsetWidth) / 2, behavior: 'smooth' });
        }
      });
    });

    var isDragging = false, startX = 0, scrollStart = 0;
    track.addEventListener('mousedown', function (e) {
      isDragging = true; startX = e.pageX; scrollStart = track.scrollLeft;
      track.style.userSelect = 'none';
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      track.scrollLeft = scrollStart - (e.pageX - startX);
    });
    window.addEventListener('mouseup', function () {
      isDragging = false; track.style.userSelect = '';
    });
  }

  document.querySelectorAll('.urvee-story-section').forEach(initStoryCarousel);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.urvee-story-section') || e.target;
    if (s.classList.contains('urvee-story-section')) initStoryCarousel(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urvee-transparency"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPillarCarousel(section) {
    var track = section.querySelector('[id^="UrveePillarsTrack-"]');
    var dotsWrap = section.querySelector('[id^="UrveePillarsDots-"]');
    if (!track) return;

    var cards = Array.from(track.children);
    var dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.urvee-trans__dot')) : [];
    var activeIdx = 0;

    function setActive(idx) {
      if (idx === activeIdx && cards[idx] && cards[idx].classList.contains('is-active')) return;
      activeIdx = idx;
      cards.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('urvee-trans__dot--active', i === idx); });
    }

    function onScroll() {
      var centre = track.scrollLeft + track.offsetWidth / 2;
      var closest = 0, minDist = Infinity;
      cards.forEach(function (c, i) {
        var dist = Math.abs((c.offsetLeft + c.offsetWidth / 2) - centre);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      setActive(closest);
    }

    setActive(0);
    track.addEventListener('scroll', onScroll, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10);
        var target = cards[idx];
        if (target) {
          track.scrollTo({ left: target.offsetLeft - (track.offsetWidth - target.offsetWidth) / 2, behavior: 'smooth' });
        }
      });
    });

    var isDragging = false, startX = 0, scrollStart = 0;
    track.addEventListener('mousedown', function (e) {
      isDragging = true; startX = e.pageX; scrollStart = track.scrollLeft;
      track.style.userSelect = 'none';
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      track.scrollLeft = scrollStart - (e.pageX - startX);
    });
    window.addEventListener('mouseup', function () {
      isDragging = false; track.style.userSelect = '';
    });
  }

  document.querySelectorAll('.urvee-trans-section').forEach(initPillarCarousel);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.urvee-trans-section') || e.target;
    if (s.classList.contains('urvee-trans-section')) initPillarCarousel(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urvee-why-urvee"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWhyCarousel(section) {
    var track = section.querySelector('[id^="UrveeWhyTrack-"]');
    var dotsWrap = section.querySelector('[id^="UrveeWhyDots-"]');
    if (!track) return;

    var cards = Array.from(track.children);
    var dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.urvee-why__dot')) : [];
    var activeIdx = 0;

    function setActive(idx) {
      if (idx === activeIdx && cards[idx].classList.contains('is-active')) return;
      activeIdx = idx;
      cards.forEach(function (c, i) {
        c.classList.toggle('is-active', i === idx);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('urvee-why__dot--active', i === idx);
      });
    }

    function onScroll() {
      var centre = track.scrollLeft + track.offsetWidth / 2;
      var closest = 0;
      var minDist = Infinity;
      cards.forEach(function (c, i) {
        var cardCentre = c.offsetLeft + c.offsetWidth / 2;
        var dist = Math.abs(centre - cardCentre);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      setActive(closest);
    }

    setActive(0);
    track.addEventListener('scroll', onScroll, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10);
        var target = cards[idx];
        if (target) {
          track.scrollTo({ left: target.offsetLeft - (track.offsetWidth - target.offsetWidth) / 2, behavior: 'smooth' });
        }
      });
    });

    /* drag-to-scroll */
    var isDragging = false, startX = 0, scrollStart = 0;
    track.addEventListener('mousedown', function (e) {
      isDragging = true; startX = e.pageX; scrollStart = track.scrollLeft;
      track.style.userSelect = 'none';
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      track.scrollLeft = scrollStart - (e.pageX - startX);
    });
    window.addEventListener('mouseup', function () {
      isDragging = false; track.style.userSelect = '';
    });
  }

  document.querySelectorAll('.urvee-why-section').forEach(initWhyCarousel);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.urvee-why-section') || e.target;
    if (s.classList.contains('urvee-why-section')) initWhyCarousel(s);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
